import { Injectable } from "@angular/core";
import { MyForm } from "@models/my-form";
import { AbstractClass, TabCells } from "@classes/abstract.class";

@Injectable({providedIn: 'root'})
export class MyFormClass extends AbstractClass {
  model: MyForm;
  modelName = '';
  idName = '';
  langBase = "landing.form.";
  route = '';
  modelCells = [];
  formCells = [];
  tableCells = [];
  tabs: TabCells[] = [];

  constructor()
  {
    super();
    this.model = {
      q1: false,
      q2: false,
      q3: false,
      q4: false,
      q5: false,
      q6: false,
      q7: false,
      q8: false,
      q9: false,
      q10: false,
      full_name: "",
      date: new Date(),
      employee_number: '',
      work_area: "",
      signature: {
        uri: "",
        timestamp: new Date(),
        height: 0,
        fileName: "",
        data: ""
      }
    };
  }
}
